import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { HubspotAuthService } from '../services/hubspot-auth-service';
import { RedirectRouteStorageService } from '../../core/services/redirect-route-storage-service';
import { AuthContext } from '../models/auth-context';
import { map, timer } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  const hubspotAuthService = inject(HubspotAuthService);
  const redirectRouteStorageService = inject(RedirectRouteStorageService);
  const router = inject(Router);

  if (hubspotAuthService.isAuthenticated()) {
    return true;
  }

  redirectRouteStorageService.set(state.url);

  router.navigate(['/auth/hubspot'], { queryParams: route.queryParams });
  return false;
};
